module.exports = __webpack_public_path__ + "img/u1261.67f2f3b6.svg";